import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { Toaster } from 'react-hot-toast';
import FeedbackForm from './components/FeedbackForm';
import NotFound from './components/NotFound';

function App() {
  return (
    <Router>
      <div className="min-h-screen bg-gray-50">
        <Toaster position="top-right" />
        <Routes>
          <Route path="/" element={<FeedbackForm />} />
          <Route path="*" element={<NotFound />} />          
        </Routes>
      </div>
    </Router>
  );
}

export default App;